import React from 'react';
import HeroProfile from './HeroProfile';
import ChatWidget from '../chatbot/ChatWidget';
import NewsWidget from './NewsWidget';

const BentoGrid = () => {
    return (
        <div className="bento-grid-container" style={{
            maxWidth: '100%',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            alignItems: 'stretch'
        }}>
            {/* Left Column: Intro (Main Focus) */}
            <div style={{ flex: '4 1 800px', minWidth: '300px', display: 'flex', flexDirection: 'column' }}>
                <HeroProfile />
            </div>

            {/* Right Column: News & Chat (Sidebar) */}
            <div style={{
                flex: '1 1 350px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
            }}>
                {/* News - Auto height */}
                <NewsWidget />

                {/* Chat - Fills remaining space */}
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <ChatWidget />
                </div>
            </div>
        </div>
    );
};

export default BentoGrid;
